import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography
} from "components/controls/widget";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import * as moment from "moment";
import { Payment } from "common/api/Payments";

interface PlatebniUdajeProps {
    show: boolean;
    payment: Payment;
    close: () => void;
}


class PlatebniUdaje extends React.PureComponent<PlatebniUdajeProps & WithStyles<typeof styles>> {

    getDate = (date: Date) => {
        return moment(date).format('D. M. YYYY');
    }

    getCastka = (c: number) => {
        return `${c} Kč`;
    }

    render() {
        const { classes, show, payment, close } = this.props;

        return <Dialog open={show} fullWidth maxWidth="sm" >
            <DialogTitle disableTypography className={classes.titleRoot}>
                <Typography variant="h6">{'Platební údaje'}</Typography>
                <IconButton aria-label="Close" className={classes.titleCloseButton} onClick={close}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.contentRoot}>
                {payment && <Grid container direction="row" spacing={16} >
                    <Grid item sm={8}>
                        <Grid container direction="column" justify="space-between">
                            <Grid container direction="row" spacing={16}>
                                <Grid item sm={6}><Typography variant="h6">{'Částka:'}</Typography></Grid>
                                <Grid item sm={6}><Typography variant="h6">{this.getCastka(payment.amount)}</Typography></Grid>
                            </Grid>
                            <Grid container direction="row" spacing={16}>
                                <Grid item sm={6}><Typography variant="h6">{'Variabilní symbol:'}</Typography></Grid>
                                <Grid item sm={6}><Typography variant="h6">{payment.variableSymbol}</Typography></Grid>
                            </Grid>
                            <Grid container direction="row" spacing={16}>
                                <Grid item sm={6}><Typography variant="h6">{'Specifický symbol:'}</Typography></Grid>
                                <Grid item sm={6}><Typography variant="h6">{payment.specificSymbol}</Typography></Grid>
                            </Grid>
                            <Grid container direction="row" spacing={16}>
                                <Grid item sm={6}><Typography variant="h6">{'Číslo účtu:'}</Typography></Grid>
                                <Grid item sm={6}><Typography variant="h6">{'129453027/0300'}</Typography></Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={4}>
                        <img src={`../../../../../api/payments/${payment.ownerId}/${payment.id}/qrcode`} width={150} height={150} />
                    </Grid>
                </Grid>}
            </DialogContent>
            <DialogActions className={classes.actionsRoot}>

                <Grid container direction="row" spacing={8}>
                    <Grid item>
                        <Button variant="contained" color="primary" onClick={close}>{'Zavřít'}</Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>;
    }
}


const styles = (theme: Theme) => createStyles({
    titleRoot: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    titleCloseButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
    contentRoot: {
        paddingTop: theme.spacing.unit * 2,
    },
    actionsRoot: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
});


export default withStyles(styles)(PlatebniUdaje);
